define('UnitOfMeasure.ProductDetails.QuickView.View', [
    'ProductViews.Price.View',
    'ProductDetails.QuickView.View',
    'underscore'
], function UnitOfMeasureProductViewsBaseView(
    ProductViewsPriceView,
    ProductDetailsQuickViewView,
    _
) {
    'use strict';

    _.extend(ProductDetailsQuickViewView.prototype, {

        initialize: _.wrap(ProductDetailsQuickViewView.prototype.initialize, function initialize(fn) {
            var self = this;
            fn.apply(this, _.toArray(arguments).slice(1));
            this.application.on('change:priceschedule', function onPriceScheduleChange(priceSchedule) {
                var pricingSchedule = [];
                priceSchedule.each(function eachPricingSchedule(schedule) {
                    pricingSchedule.push({
                        "maximumquantity": schedule.get('maximumquantity') && parseInt(schedule.get('maximumquantity'), 10),
                        "minimumquantity": parseInt(schedule.get('minimumquantity') || 0, 10),
                        "price": schedule.get('price') && parseFloat(schedule.get('price'), 10),
                        "price_formatted": schedule.get('price_formatted')
                    })
                });

                self.model.getItem().set('priceschedule', pricingSchedule);
                if (self.model.getItem().attributes._priceDetails) {
                    delete self.model.getItem().attributes._priceDetails;
                }

                self.renderChild('Product.Price');
            });
        }),

        childViews: _.extend(ProductDetailsQuickViewView.prototype.childViews || {}, {
            'Product.Price': function () {
                return new ProductViewsPriceView({
                    model: this.model,
                    origin: this.inModal ? 'PDPQUICK' : 'PDPFULL',
                    isPdp: true
                });
            }
        })
    });
});
